<template>
  <template v-if="pageListChild == 'maintainexecution'">
    <!-- 保養執行表 -->
    <maintainExecution></maintainExecution>
  </template>
  <template v-else-if="pageListChild == 'maintainschedule'">
    <!-- 編輯保養計畫 -->
    <maintainSchedule></maintainSchedule>
  </template>
</template>

<script>
import maintainExecution from "@/components/deviceManagement/maintain/maintainExecution";
import maintainSchedule from "@/components/deviceManagement/maintain/maintainSchedule";
import { inject } from "vue";
export default {
  components: {
    maintainExecution,
    maintainSchedule,
  },
  setup() {
    const pageListChild = inject("pageListChild");

    return {
      pageListChild,
    };
  },
};
</script>

<style></style>
